import React from "react";
import FeesContext from ".";
import { IDynamicFees } from "views/admin/dynamicFees/types/fees.interface";

type FeesProvideProps = {
  children: React.ReactNode;
};

export const FeesProvider: React.FC<FeesProvideProps> = ({ children }) => {
  const [fees, setFees] = React.useState<IDynamicFees[]>([]);

  const value = {
    fees,
    setFees,
  };

  return <FeesContext.Provider value={value}>{children}</FeesContext.Provider>;
};
